import { FormEvent, useState } from "react";
import Footer from "../components/Footer";
import Form from "../components/Form";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import { sendContact } from "../services/api";
import { useNotification } from "../contexts/NotificationContext";
import ScrollToTop from "react-scroll-to-top";

// CONST

const desc =
	"Pour toute demande d'information, privatisation ou simple prise de contact, utilisez le formulaire ci-contre. Nous vous répondrons dans les plus brefs délais.";

function Contact() {
	const { notify } = useNotification();
	// STATES
	const [isSending, setIsSending] = useState<boolean>(false);
	// HANDLE
	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const data = new FormData(e.currentTarget);
		const name = data.get("nom") as string;
		const firstname = data.get("prenom") as string;
		const message = data.get("message") as string;
		const mail = data.get("mail") as string;
		const request = message + "\n\n" + name + " " + firstname + "\n" + mail;
		setIsSending(true);
		const response = await sendContact(request);
		setIsSending(false);
		if (response) {
			notify({
				type: "validation",
				title: "Message Envoyé",
				subtitle: "Votre demande à été prise en compte",
			});
			const resetForm = e.target as HTMLFormElement;
			resetForm.reset();
		} else {
			notify({ type: "error", title: "Demande Échouée..." });
		}
	};
	// COMPONENT
	return (
		<div className="contact">
			<Navbar />
			<Hero
				title="Nous Contacter"
				subtitle="NOTRE ÉQUIPE VOUS ÉCOUTE"
				image="/assets/hero/contact.jpg"
			/>
			<Form title="Contactez Notre Équipe" description={desc}>
				<form onSubmit={(e) => handleSubmit(e)}>
					<div>
						<input
							type="text"
							name="prenom"
							required
							placeholder="prénom"
						/>
						<input
							type="text"
							name="nom"
							required
							placeholder="nom"
						/>
					</div>
					<input
						type="mail"
						name="mail"
						required
						placeholder="nom.prenom@mail.com"
					/>
					<textarea
						name="message"
						placeholder="tapez votre message..."
						required
					/>
					<button type="submit" disabled={isSending}>
						{" "}
						<span className="primary-text">ENVOYER</span>
					</button>
				</form>
			</Form>
			<Footer />
		</div>
	);
}

export default Contact;
